import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		//name: 'PTU Computer Vision POC'
	}
});

export default app;